import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export const UpdateBestAction = gql`
  mutation UpdateBestAction($input: UpdateBestActionInput!) {
    updateBestAction(input: $input) {
      ... on UpdateBestActionError {
        __typename
        ...error
      }
      ... on UpdateBestActionSuccess {
        __typename
        isSuccess: success
      }
    }
  }
  ${error}
`;
